<template>
    <el-container class="userManagement-box" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">指标名称</span>
                <el-input
                    placeholder="请输入"
                    class="input-box"
                    clearable
                    v-model.trim="form.likeItemName"
                ></el-input>
            </div>
            <el-button class="search-btn" type="primary" v-auth="'sa_user_abnormal_page'" @click="getData(true)">查询</el-button>
            <el-button class="search-btn" v-auth="'sa_item_page'" type="primary" @click="() => $root.showPage = false">重置</el-button>
        </div>
        <div class="cont-x">
            <div class="table-x" ref="tableBox">
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    border
                    class="mb20"
                >
                    <el-table-column
                        prop="examTime"
                        align="center"
                        label="生成时间"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="indexName"
                        align="center"
                        label="指标名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="normalRange"
                        align="center"
                        label="正常参考值"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="indexResultValue"
                        align="center"
                        label="结果值"
                    >
                    </el-table-column>
                    <!-- <el-table-column
                        prop="indexResultType"
                        align="center"
                        label="异常提示"
                    >
                    </el-table-column>
                    <el-table-column align="center" label="异常等级">
                        <template slot-scope="scope">
                            {{ scope.row.createTime | anomalyLevel }}
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
        </div>
        <div class="pagenation-x">
            <div class="pagination mb20">
                <el-pagination
                    @size-change="getData"
                    @current-change="getData"
                    :current-page.sync="page.pageNo"
                    :page-size.sync="page.pageSize"
                    layout="total,  prev, pager, next, jumper"
                    :total="page.total"
                    background
                >
                </el-pagination>
            </div>
        </div>
    </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "detailAbnormal",
    data() {
        return {
            /**
             * 表单相关
             */
            // 查询条件
            form: {}, // form 信息
            /**
             * 表格相关
             */
            loading: true,
            // 页数相关信息
            page: {
                pageSize: 10,
                pageNo: 1,
                total: 0,
            },
            tableData: [], // 表格数据
        };
    },
    computed: {
        ...mapGetters(["authMap"]),
    },
    methods: {
        /**
         * 重置表单
         */
        resetForm() {
            this.form = {};
            this.$forceUpdate();
        },
        /**
         * 获取数据
         */
        async getData(resetPage) {
            if (resetPage === true) this.page.pageNo = 1
            this.loading = true;
            let res = await this.axios.get(this.getApiUrl("userAbnormalPage"), {
                params: Object.assign(
                    {
                        userId: this.$route.query.userId,
                    },
                    this.form,
                    this.page
                ),
            });
            this.tableData = res?.data?.data || [];
            this.page.total = res?.data?.total || 0;
            this.loading = false;
        },
    },
    filters: {
        /**
         * 异常等级filters
         */
        anomalyLevel(text) {
            return text;
        },
    },
    created() {
        // 面包导航
        this.$root.breadList = [
            { name: "档案信息", link: "" },
            { name: "异常指标解读", link: "" },
        ];
    },
    mounted() {
        if (!this.authMap['sa_user_abnormal_page']){
            this.loading = false
            this.$message.error('抱歉，您暂无权限')
            return
        }
        this.getData();
    },
};
</script>

<style type="text/scss" lang="scss" scoped>
.userManagement-box {
    .search-x {
        min-height: 120px;
        flex-shrink: 0;
    }
    .cont-x {
        flex: 1;
        flex-shrink: 0;
    }
}
</style>